<template>
    <div class="blackout" :class="{blocked: blocked, show: show, supress: supress}">
        <div class="modal vertical-align">
            <div class="actions" v-if="confirmBox">
                <a href="#" class="close text-with-icon" @click.prevent="close">
                    <span>Close</span><img src="img/icons/s3/close_white.svg">
                </a>
            </div>
            <div class="content">
                <p>{{messageDisplay}}</p>
                <p class="code-inline" v-if="code">{{code}}</p>
                <p v-if="code">{{timestamp}}</p>
                <div class="button-container">
                    <a href="#" class="button" @click.prevent="okayButton">{{okayText}}</a>
                    <a href="#" class="button hollow" @click.prevent="cancelButton" v-if="confirmBox">{{cancelText}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'Modal',
        components: {},
        data: function() {
            return {
                show: false,
                blocked: false,
                timeout: null,
                messageDisplay: null,
                timestamp: null
            };
        },
        computed: {
            message() {
                return this.$store.state.messageBox.message;
            },
            code() {
                return this.$store.state.messageBox.code;
            },
            okayText() {
                return this.$store.state.messageBox.okayText;
            },
            okayFunction() {
                return this.$store.state.messageBox.okayFunction;
            },
            cancelText() {
                return this.$store.state.messageBox.cancelText;
            },
            cancelFunction() {
                return this.$store.state.messageBox.cancelFunction;
            },
            confirmBox() {
                return this.$store.state.messageBox.confirmBox;
            },
            supress() {
                //Suppresses this display if this higher priority overlay is active
                return  (this.$store.state.activity.error.fatal ? true : false);
            }
        },
        watch: {
            message() {
                // messageDisplay used to store message so it does not dissapear while messageBox is transistioning out on close
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if (this.message !== null){
                    this.messageDisplay = this.message;
                } else {
                    this.timeout = setTimeout(() => {
                        this.messageDisplay = null;
                    }, 500);
                }
                this.toggleDisplay();

            },
            show() {
                if (this.show === true){
                    document.body.classList.add('no-scroll'); 
                } else {
                    document.body.classList.remove('no-scroll'); 
                }
            }
        },
        created: function () {
            this.timestamp = moment().format();
        },
        methods: {
            toggleDisplay() {
                
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if(this.message) {
                    this.show = false;
                    this.blocked = true;
                    this.timeout = setTimeout(() => {
                        this.show = true;
                    }, 10);
                } else {           
                    this.blocked = true;
                    this.show = false;
                    this.timeout = setTimeout(() => {
                        this.blocked = false;
                    }, 500);
                }
                
            }, 
            close() {
                this.$store.dispatch('closeMessageBox');
            },
            okayButton() {
                if(this.show){
                    this.close();
                    if(this.okayFunction){
                        this.okayFunction();
                    }
                }
            },
            cancelButton() {
                if(this.show){
                    this.close();
                    if(this.cancelFunction){
                        this.cancelFunction();
                    }
                }
            }
            
        }
    };
</script>

<style scoped>
    
    .blackout {background-color: rgba(0,0,0,.75); position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 999; opacity: 0; transition: .5s; display: none;}
    .blackout.show {opacity: 1;}
    .blackout.blocked {display: block;}
    .blackout.supress {opacity: 0!important;}
        .blackout > .spinner {position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto;}
        .blackout > .message {position: absolute; top: 30vh; right: 30vw; bottom: 30vh; left: 30vw; margin: auto; color:white;}
            .blackout > .message .error {color:orangered;}
            .blackout > .message a {color:#fff;}
            .blackout > .message .cta-link {margin-top: 2rem;}
    
    .modal {width: 90vw; max-width: 35rem; position: absolute; right: 0; left: 0; margin: auto; transition: .25s; text-align: center;}
    .show .modal {}
        .modal > .actions {height: 2rem; text-align: right; opacity: 0; transition: .75s;}
        .show .modal > .actions {opacity: 1;}
            .modal > .actions .close {color: #fff; text-transform: uppercase;}
        .modal > .content {width: 90vw; max-width: 100%; padding: 1.75rem; height: calc(100% - 2rem); overflow-y: auto; box-sizing: border-box; background: #F0EEEE; opacity: 0; transform: translateY(5rem); transition: .5s;}
        .show .modal > .content {opacity: 1; transform: translateY(0);}

</style>